import React from 'react';
import { Package } from 'lucide-react';

function ProductIncentiveCard({ data, handleInputChange }) {
  return (
    <div className="bg-white border rounded-lg p-6">
      <div className="flex items-center mb-4">
        <div className="p-2 bg-blue-100 rounded-lg mr-3">
          <Package className="h-5 w-5 text-blue-600" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900">Product Incentive</h3>
      </div>

      <div className="space-y-4">
        {/* Status Toggle */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium text-gray-700">Enable Product Incentive</label>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={data.status}
              onChange={(e) => handleInputChange('productIncentive', 'status', e.target.checked)}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
          </label>
        </div>

        {/* Incentive Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Incentive Type
          </label>
          <select
            value={data.type}
            onChange={(e) => handleInputChange('productIncentive', 'type', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            disabled={!data.status}
          >
            <option value="percentage">Percentage</option>
          </select>
        </div>

        {/* Multiple Of */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Multiple Of
          </label>
          <select
            value={data.of}
            onChange={(e) => handleInputChange('productIncentive', 'of', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            disabled={!data.status}
          >
            <option value="sale">Sale</option>
          </select>
        </div>

        {/* Target Value */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Target {'percentage (%)'}
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            value={data.tragetvalue}
            onChange={(e) => handleInputChange('productIncentive', 'tragetvalue', parseFloat(e.target.value) || 0)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Enter value"
            disabled={!data.status}
          />
        </div>
      </div>
    </div>
  );
}

export default ProductIncentiveCard;